"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreespinsGames = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useQuery_1 = require("../useQuery");
var country_1 = require("../country");
var useFreespinsGames = function (_a) {
    var id = _a.id;
    var country = (0, country_1.useProfileCountry)();
    var _b = (0, useQuery_1.useQuery)({
        canRender: !!id && country,
        path: "".concat(keys_1.GAME_FREESPINS, "/").concat(id),
        revalidateOnMount: true,
        payload: {
            country: country,
        },
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate, isValidating = _b.isValidating;
    return (0, react_1.useMemo)(function () { return ({
        mutate: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data, isLoading, isValidating, mutate, error]);
};
exports.useFreespinsGames = useFreespinsGames;
